import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Thinking from "../../Public/thinkingGraphic.png";
import "./KnowledgeBase.css";

function KnowledgeBase() {
  return (
    <Container fluid>
      <Row className="justify-content-center align-items-center">
        <Col lg={10}>
          <Row className="justify-content-center align-items-center">
            <Col lg={7} className="center support-header">
              <h1>¿Tienes dudas?</h1>
              <p className="left">
                Esta sección está dedicada a ayudarte a naevegar por la
                plataforma. Encontrarás las preguntas más frecuentes resueltas a
                través de videos cortos. Al hacer click en la pregunta te
                desplegará un video que explica detalladamente el tema clave de
                la pregunta.
              </p>
            </Col>
            <Col lg={3} className="center">
              <img
                src={Thinking}
                alt="Knowledge Base"
                className="img-fluid"
                style={{ height: "200px" }}
              />
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center">
            <Col className="mt-3 support-videos">
              <h3 className="mt-4 mb-2">Reconocimientos</h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo enviar y visualizar reconocimientos?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138808?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Reconocimientos"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h3 className="mt-4 mb-2">Hobbies</h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo buscar personas con mis mismos hobbies?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138793?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Hobbies"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h3 className="mt-4 mb-2">Reuniones 1 a 1</h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo crear y solicitar una reunión 1 a 1?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138706?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Nueva reunión 1 a 1"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo participar en una reunión 1 a 1?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138690?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Participar en una reunión 1 a 1"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h3 className="mt-4 mb-2">Evaluación de desempeño por periodo</h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo es un proceso de evaluación del desempeño?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092960714?h=c0584a27cb&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Proceso Evaluación del desempeño"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo dar de alta mis objetivos?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092347042?h=c296f34961&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Alta de objetivos"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo validar los objetivos de mi equipo?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092680217?h=328b91afcc&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Validación de objetivos"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo reportar los cumplimientos de mis objetivos?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092680213?h=22e0e8dac7&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Reporte de cumplimientos"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo validar los cumplimientos de mis objetivos?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092927214?h=62c16dbcc7&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Validación de cumplimientos"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h3 className="mt-4 mb-2">
                Evaluación de talento por competencias
              </h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo contestar una evaluación de competencias?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1092291913?h=91b3fa60d0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Evaluación de competencias"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h3 className="mt-4 mb-2">Planes de desarrollo</h3>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo solicitar una capacitación?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138780?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Solicitar una capacitación"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <h6 className="support-question">
                      ¿Cómo reportar el cumplimiento de una capacitación?
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <iframe
                      src="https://player.vimeo.com/video/1174138759?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{
                        width: "800px",
                        height: "600px",
                      }}
                      title="Reportar cumplimiento de capacitación"
                    ></iframe>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default KnowledgeBase;
